const values = {
    "AGENCY_CONFIGURATIONS": "Configuraciones",
    "DOCUMENT_SETTINGS": "Documentos",
    "DOCUMENT_SETTINGS_DESCRIPTION": "Define qué datos aparecen como emisor en las facturas, hojas de entrega y etiquetas que reciben tus clientes y destinatarios.",
    "DOCUMENT_ISSUER_MODE_AGENCY": "Datos de la agencia",
    "DOCUMENT_ISSUER_MODE_AGENCY_DESCRIPTION": "Se muestran el nombre, teléfono, dirección y correo de la agencia.",
    "DOCUMENT_ISSUER_MODE_CUSTOM": "Datos personalizados",
    "DOCUMENT_ISSUER_MODE_CUSTOM_DESCRIPTION": "Se muestran solo los datos que escribas aquí. Los campos vacíos no se imprimen.",
    "DOCUMENT_ISSUER_MODE_HIDDEN": "Sin datos del emisor",
    "DOCUMENT_ISSUER_MODE_HIDDEN_DESCRIPTION": "No se muestra ningún dato del emisor en los documentos.",
    "DOCUMENT_ISSUER_DATA": "Datos del emisor",
    "DOCUMENT_ISSUER_PREVIEW": "Así se verá en los documentos",
    "DOCUMENT_ISSUER_PREVIEW_EMPTY": "Los documentos no mostrarán datos del emisor",
    "DOCUMENT_FOOTER_NOTE": "Nota adicional",
    "DOCUMENT_FOOTER_NOTE_PLACEHOLDER": "Texto libre que se imprime debajo de los datos del emisor",
}

export default values;
